import { useLocation, Outlet, Navigate } from "react-router-dom";
import Header from "../components/header";

const Home = () => {
    const location = useLocation();

    // Guard: if navigated to without login state, bounce to login
    if (!location.state?.data) {
        return <Navigate to="/" replace />;
    }

    const { data } = location.state;

    // Check if user is admin
    const isAdmin = data?.data?.clientDetails?.isAdmin === true;

    // landing at /home or /home/ redirect based on role
    if (location.pathname === "/home" || location.pathname === "/home/") {
        return isAdmin
            ? <Navigate to="/home/admin" replace state={{ data: location.state.data }} />
            : <Navigate to="/home/dashboard" replace state={{ data: location.state.data }} />;
    }

    return (
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "var(--surface-bg)" }}>
            <Header data={data} />
            <main style={{ flex: 1, padding: "28px 32px" }}>
                <Outlet context={{ data }} />
            </main>
        </div>
    );
};

export default Home;
